export const authRoutes = [
  {
    path: '/auth',
    redirect: '/auth/login',
    meta: { toDash: true },
  },
  {
    path: '/auth/sso',
    component: () => import('../views/auth/SSORedirectView.vue'),
    meta: { layout: 'AuthLayout', title: 'SSO' },
  },
  {
    path: '/auth/login',
    component: () => import('../views/auth/LoginView.vue'),
    meta: {
      toDash: true,
      layout: 'AuthLayout',
      title: 'Login',
    },
  },
  {
    path: '/auth/register',
    component: () => import('../views/auth/RegisterView.vue'),
    meta: {
      toDash: true,
      layout: 'AuthLayout',
      title: 'Register',
    },
  },
  {
    path: '/auth/invite',
    component: () => import('../views/auth/InviteView.vue'),
    meta: {
      layout: 'AuthLayout',
      title: 'Invitation',
    },
  },
  {
    path: '/auth/reset',
    component: () => import('../views/auth/ResetPasswordView.vue'),
    meta: { layout: 'AuthLayout', title: 'Reset Password' },
  },
  {
    path: '/auth/verifyChange',
    component: () => import('../views/auth/verifyChangeView.vue'),
    meta: { layout: 'AuthLayout', title: 'Verify Email' },
  },
  {
    path: '/auth/recoverEmail',
    component: () => import('../views/auth/revertEmailView.vue'),
    meta: { layout: 'AuthLayout', title: 'Recover Email' },
  },
  {
    path: '/auth/verifyEmail',
    component: () => import('../views/auth/verifyEmailView.vue'),
    meta: { layout: 'AuthLayout', title: 'Verify Email' },
  },
  {
    path: '/auth/sso-logout',
    component: () => import('../views/auth/SSOLogoutView.vue'),
    meta: {
      layout: 'AuthLayout',
      title: 'Logging out',
    },
  },
];
